import axios from 'axios'
export const authSlice = (set,get) => ({
    token:null,
    isAuthenticated:false,
    setIsAuthenticate : (boolval) =>set((state)=>({isAuthenticated:boolval})),
    setToken : (newToken) =>set((state)=>({token:newToken})),

    logout :() =>{
        set({token:null,user:null,isAuthenticated:false});
    },
})
